const Mutations = Object.freeze({
	SET_ALL_VISIBLE_WORKBOOKS: 'reportsModule/report/SET_ALL_VISIBLE_WORKBOOKS',
	SET_ALL_VISIBLE_REPORT_PREVIEWS:
		'reportsModule/report/SET_ALL_VISIBLE_REPORT_PREVIEWS',
	SET_SELF_CREATED_REPORT_PREVIEWS:
		'reportsModule/report/SET_SELF_CREATED_REPORT_PREVIEWS',
	SET_ASSIGNED_REPORT_PREVIEWS:
		'reportsModule/report/SET_ASSIGNED_REPORT_PREVIEWS',
	SET_ADMIN_REPORT_PREVIEWS: 'reportsModule/report/SET_ADMIN_REPORT_PREVIEWS',
	SET_LOADING: 'reportsModule/report/SET_LOADING',
	REMOVE_REPORT_PREVIEW: 'reportsModule/report/REMOVE_REPORT_PREVIEW',
});

export const Actions = Object.freeze({
	CLEAR: 'reportsModule/report/CLEAR',
	LOAD_REPORT_PREVIEWS: 'reportsModule/report/LOAD_REPORT_PREVIEWS',
	LOAD_ADMIN_REPORT_PREVIEWS:
		'reportsModule/report/LOAD_ADMIN_REPORT_PREVIEWS',
	DELETE_REPORT_PREVIEW: 'reportsModule/report/DELETE_REPORT_PREVIEW',
});

export const Getters = Object.freeze({
	LOADING_REPORTS: 'reportsModule/report/LOADING_REPORTS',
	ALL_VISIBLE_REPORT_PREVIEWS:
		'reportsModule/report/ALL_VISIBLE_REPORT_PREVIEWS',
	SELF_CREATED_REPORT_PREVIEWS:
		'reportsModule/report/SELF_CREATED_REPORT_PREVIEWS',
	ASSIGNED_REPORT_PREVIEWS: 'reportsModule/report/ASSIGNED_REPORT_PREVIEWS',
	ADMIN_REPORT_PREVIEWS: 'reportsModule/report/ADMIN_REPORT_PREVIEWS',
	MENU_ITEMS_REPORTS_PREVIEWS:
		'reportsModule/report/MENU_ITEMS_REPORTS_PREVIEWS',
	ALL_VISIBLE_WORKBOOKS: 'reportsModule/report/ALL_VISIBLE_WORKBOOKS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';
import reportGrid from './reportGrid';
import reportWorkbook from './reportWorkbook';
export default {
	state: {
		selfCreatedReportPreviews: [],
		allVisibleReportPreviews: [],
		assignedReportPreviews: [],
		adminReportPreviews: [],
		allVisibleWorkbooks: [],
		loading: false,
	},
	modules: { reportGrid, reportWorkbook },
	mutations: {
		[Mutations.SET_ASSIGNED_REPORT_PREVIEWS](state, items) {
			state.assignedReportPreviews = items;
		},
		[Mutations.SET_ALL_VISIBLE_REPORT_PREVIEWS](state, items) {
			state.allVisibleReportPreviews = items;
		},
		[Mutations.SET_SELF_CREATED_REPORT_PREVIEWS](state, items) {
			state.selfCreatedReportPreviews = items;
		},
		[Mutations.SET_ADMIN_REPORT_PREVIEWS](state, items) {
			state.adminReportPreviews = items;
		},
		[Mutations.SET_ALL_VISIBLE_WORKBOOKS](state, items) {
			state.allVisibleWorkbooks = items;
		},
		[Mutations.SET_LOADING](state, val) {
			state.loading = val;
		},
		[Mutations.REMOVE_REPORT_PREVIEW](state, item) {
			let itemToRemove = state.reportPreviews.find(
				(x) =>
					x.ReportId == item.ReportId &&
					x.GridViewId == item.GridViewId
			);
			if (item) {
				let index = state.reportPreviews.indexOf(itemToRemove);
				state.reportPreviews.splice(index, 1);
			}
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_ALL_VISIBLE_REPORT_PREVIEWS, []);
				commit(Mutations.SET_ASSIGNED_REPORT_PREVIEWS, []);
				commit(Mutations.SET_SELF_CREATED_REPORT_PREVIEWS, []);
				commit(Mutations.SET_ADMIN_REPORT_PREVIEWS, []);
				commit(Mutations.SET_ALL_VISIBLE_WORKBOOKS, []);
				commit(Mutations.SET_LOADING, false);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_REPORT_PREVIEWS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getReportPreviews()
					.then((resp) => {
						commit(
							Mutations.SET_ALL_VISIBLE_REPORT_PREVIEWS,
							resp.data.AllVisibleReports
						);
						commit(
							Mutations.SET_ASSIGNED_REPORT_PREVIEWS,
							resp.data.AssignedReports
						);
						commit(
							Mutations.SET_SELF_CREATED_REPORT_PREVIEWS,
							resp.data.SelfCreatedReports
						);
						commit(
							Mutations.SET_ALL_VISIBLE_WORKBOOKS,
							resp.data.AllVisibleWorkbooks
						);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},
		[Actions.LOAD_ADMIN_REPORT_PREVIEWS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getAdminReportPreviews()
					.then((resp) => {
						commit(Mutations.SET_ADMIN_REPORT_PREVIEWS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},
		[Actions.DELETE_REPORT_PREVIEW]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteReportPreview(item)
					.then(() => {
						commit(Mutations.REMOVE_REPORT_PREVIEW, item);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},

	getters: {
		[Getters.LOADING_REPORTS]: (state) => {
			return state.loading;
		},
		[Getters.ALL_VISIBLE_REPORT_PREVIEWS]: (state) => {
			if (!state.allVisibleReportPreviews) return [];
			if (state.allVisibleReportPreviews.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.allVisibleReportPreviews));
		},
		[Getters.ADMIN_REPORT_PREVIEWS]: (state) => {
			if (!state.adminReportPreviews) return [];
			if (state.adminReportPreviews.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.adminReportPreviews));
		},
		[Getters.SELF_CREATED_REPORT_PREVIEWS]: (state) => {
			if (!state.selfCreatedReportPreviews) return [];
			if (state.selfCreatedReportPreviews.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.selfCreatedReportPreviews));
		},
		[Getters.ASSIGNED_REPORT_PREVIEWS]: (state) => {
			if (!state.assignedReportPreviews) return [];
			if (state.assignedReportPreviews.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.assignedReportPreviews));
		},
		[Getters.ALL_VISIBLE_WORKBOOKS]: (state) => {
			if (!state.allVisibleWorkbooks) return [];
			if (state.allVisibleWorkbooks.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.allVisibleWorkbooks));
		},

		[Getters.MENU_ITEMS_REPORTS_PREVIEWS]: (state) => {
			let result = [];
			if (state.adminReportPreviews) {
				state.adminReportPreviews.forEach((report) => {
					let exists = result.find(
						(x) =>
							x.ReportId == report.ReportId &&
							x.GridViewId == report.GridViewId
					);
					if (!exists) result.push(report);
				});
			}

			if (state.selfCreatedReportPreviews) {
				state.selfCreatedReportPreviews.forEach((report) => {
					let exists = result.find(
						(x) =>
							x.ReportId == report.ReportId &&
							x.GridViewId == report.GridViewId
					);
					if (!exists) result.push(report);
				});
			}

			if (state.allVisibleReportPreviews) {
				state.allVisibleReportPreviews.forEach((report) => {
					let exists = result.find(
						(x) =>
							x.ReportId == report.ReportId &&
							x.GridViewId == report.GridViewId
					);
					if (!exists) result.push(report);
				});
			}

			if (state.assignedReportPreviews) {
				state.assignedReportPreviews.forEach((report) => {
					let exists = result.find(
						(x) =>
							x.ReportId == report.ReportId &&
							x.GridViewId == report.GridViewId
					);
					if (!exists) result.push(report);
				});
			}

			return result;
		},
	},
};
